import { render, staticRenderFns } from "./my_manuscript.vue?vue&type=template&id=1a486bd4&scoped=true&"
import script from "./my_manuscript.vue?vue&type=script&lang=js&"
export * from "./my_manuscript.vue?vue&type=script&lang=js&"
import style0 from "./my_manuscript.vue?vue&type=style&index=0&id=1a486bd4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a486bd4",
  null
  
)

export default component.exports